<template>
  <div id="root">
    <div style="outline:none" tabindex="-1" role="group">
      <div class="main-container">
        <div class="app-container">
          <div class="main-page-container">
            <div style="outline:none" tabindex="-1" role="group">
              <div class="page-container article-type">
                <Header />
                <div class="page-wrapper bg-layer">
                  <div class="swpier-box">
                    <swiper
                      :options="swiperOption1"
                      ref="swiperThumbs"
                      class="pro-bottom"
                    >
                      <!-- slides -->
                      <swiper-slide >
                        <img src="../assets/img/shop/01.jpg"/>
                      </swiper-slide>
                      <swiper-slide >
                        <img src="../assets/img/shop/02.jpg"/>
                      </swiper-slide>
                      <swiper-slide >
                        <img src="../assets/img/shop/03.jpg"/>
                      </swiper-slide>
                      <swiper-slide >
                        <img src="../assets/img/shop/04.jpg"/>
                      </swiper-slide>
                      <!-- Optional controls -->
                      
                      <!-- 如果需要导航条-->
                    </swiper>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-prev"></div>
                      <div class="swiper-button-next"></div>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// console.log(Swiper);
// import 'swiper/css/swiper.css'
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  name: "locator",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      id: null,
      url: "http://120.55.125.201:8006",
      list: [

      ],
      index: 0,
      nowPic: "",
      swiperOption1: {
        // 参数选项,显示小点
        loop: true,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev"
        // pagination: ".swiper-pagination"
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  async created() {
    // console.log(this.$refs.swiperThumbs)
  },
  methods: {
  }
};
</script>

<style  lang="less" scoped>
.swiper-container {
  width: 100%;
  padding-top: 50px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  background: 0 0 !important;
  width: 300px;
  display: flex;
  /*主轴居中对齐*/
  justify-content: center;
  /*侧轴居中对齐*/
  align-items: center;
}
.swiper-slide img {
  width: 100%;
}
/deep/.swiper-container-3d .swiper-slide-shadow-left {
  background-image: none;
}
/deep/.swiper-container-3d .swiper-slide-shadow-right {
  background-image: none;
}
.swpier-box {
  position: relative;
  width: 100%;
}

@media (max-width:769px) {
  .swpier-box{
    margin-top: 44px;
  }
  /deep/.swiper-slide{
  height: auto!important;
}
.swiper-container{
  margin-bottom: 0px;
}
}
.mov.active {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}
.mov {
  opacity: 0;
  transform: translate(0%, 100%) matrix(1, 0, 0, 1, 0, 0);
  transition: all 1s;
}

</style>